<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>

        <form *ngIf="loaded" #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
          <div class="row align-items-end">

            <!-- Origen -->
            <div class="col-md-3 mb-3">
              <label for="selectOrigen" class="form-label" i18n>Origen</label>
              <select class="form-select" id="selectOrigen" name="origen" [(ngModel)]="caso.origen"
                [disabled]="isCaseClosed() || disableOptions">
                <option [ngValue]="null" disabled selected i18n>Seleccione</option>
                <option *ngFor="let opcion of origenOptions" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select>
            </div>

            <!-- Sector -->
            <div class="col-md-4 mb-3">
              <label for="selectSector" class="form-label" i18n>Sector</label>
              <select class="form-select" id="selectSector" name="sector" [(ngModel)]="caso.sector"
                [disabled]="isCaseClosed() || disableOptions">
                <option [ngValue]="null" disabled selected i18n>Seleccione</option>
                <option *ngFor="let sector of sectores" [ngValue]="sector.value">{{ sector.label }}</option>
              </select>
            </div>

            <!-- Idioma -->
            <div class="col-md-2 mb-3">
              <label for="selectIdioma" class="form-label" i18n>Idioma</label>
              <select class="form-select" id="selectIdioma" name="idioma" [(ngModel)]="caso.idioma"
                [disabled]="isCaseClosed() || disableOptions">
                <option [ngValue]="null" disabled selected i18n>Seleccione</option>
                <option *ngFor="let idioma of idiomas" [ngValue]="idioma.value">{{ idioma.label }}</option>
              </select>
            </div>

            <!-- Sede -->
            <div class="col-md-3 mb-3">
              <label for="selectSede" class="form-label" i18n>Sede</label>
              <select class="form-select" id="selectSede" name="sede" [(ngModel)]="caso.sede"
                [disabled]="isCaseClosed() || disableOptions">
                <option [ngValue]="null" disabled selected i18n>Seleccione</option>
                <option *ngFor="let ciudad of ciudades" [ngValue]="ciudad.value">{{ ciudad.label }}</option>
              </select>
            </div>

            <!-- Procedimiento -->
            <div class="col-md-2 mb-3">
              <label for="selectProcedimiento" class="form-label" i18n>Procedimiento</label>
              <select class="form-select" id="selectProcedimiento" name="procedimiento" [(ngModel)]="caso.procedimiento"
                [disabled]="isCaseClosed() || disableOptions">
                <option [ngValue]="null" disabled selected i18n>Seleccione</option>
                <option *ngFor="let opcion of procedimientoOptions" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select>
            </div>

            <!-- Tipo -->
            <div class="col-md-2 mb-3">
              <label for="selectTipo" class="form-label" i18n>Tipo</label>
              <select class="form-select" id="selectTipo" name="tipo" [(ngModel)]="caso.tipo"
                [disabled]="isCaseClosed() || disableOptions">
                <option [ngValue]="null" disabled selected i18n>Seleccione</option>
                <option *ngFor="let opcion of tipoOptions" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select>
            </div>

            <!-- Audiencias -->
            <div class="col-md-2 mb-3">
              <label for="selectAudiencias" class="form-label" i18n>Audiencias</label>
              <select class="form-select" id="selectAudiencias" name="audiencias" [(ngModel)]="caso.audiencias"
                [disabled]="isCaseClosed() || disableOptions">
                <option [ngValue]="null" disabled selected i18n>Seleccione</option>
                <option *ngFor="let opcion of audienciasOptions" [ngValue]="opcion.value">{{ opcion.label }}</option>
              </select>
            </div>

            <div class="col-md-6 mb-3"></div>

            <!-- Objeto del contrato -->
            <div class="col-md-6 mb-3">
              <label for="inputObjetoContrato" class="form-label" i18n>Objeto de la controversia</label>
              <textarea class="form-control" id="inputObjetoContrato" name="objeto_contrato"
                [(ngModel)]="caso.objeto_contrato" [readonly]="isCaseClosed() || disableOptions" rows="7"></textarea>
            </div>

            <!-- Convenio arbitral -->
            <div class="col-md-6 mb-3">
              <label for="inputConvenioArbitral" class="form-label" i18n>Convenio Arbitral</label>
              <textarea class="form-control" id="inputConvenioArbitral" name="convenio_arbitral"
              [(ngModel)]="caso.convenio_arbitral" [readonly]="isCaseClosed() || disableOptions" rows="7"></textarea>
            </div>

            <!-- Botón Guardar Cambios -->
            <div class="col-md-12 text-end mb-3">
              <button type="submit" class="btn btn-primary waves-effect waves-light"
                [disabled]="f.invalid || isCaseClosed() || disableOptions" [hidden]="isCaseClosed() || disableOptions">
                <span i18n>Guardar Cambios</span>
              </button>
            </div>


          </div>
        </form>
      </div>
    </div>
  </div>
</div>